import { StatisticalAnalysisGeneralDossierExternalInfo } from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import { Nullable } from '@/shared/types/app.types'

export interface StatisticAnalysisExternalViewGeneralStatisticsState {
    externalInfo: Nullable<StatisticalAnalysisGeneralDossierExternalInfo>
}
export const initialStatisticAnalysisExternalViewGeneralStatisticsState =
    (): StatisticAnalysisExternalViewGeneralStatisticsState => ({
        externalInfo: null
    })
